import React, { useEffect, useState } from "react";
import BASEURL from "../../../Utils/Baseurl";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
  LinearProgress,
  ButtonGroup,
  Box
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Add } from "@mui/icons-material";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialSelect from "../../../../components/MasterSelect";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialButton from "../../../../components/MaterialButton";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import { request } from "graphql-request";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import MaterialDataGrid from "../../../../components/MaterialDataGrid";
import { useUserDetails } from "../../../../context/auth";
import Swal from "sweetalert2";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
const All_USER_Query = `
  query{
    allUsersDetail{
            id
        firstName
            empid
        email
        }
        }
`;
const ALL_ASSIGNED_USER = `
    query{
        allEmployeeSalery{
            id
            user{
                username
                id
            }
            }
        }
`;

const ALL_SALARY_STRUCTURE = `
    query allsalarystructure{
  salaryStructures {
    id
    structureName
    components {
      id
      percentage
      amount
      type
      calculatedFrom
      }
    }
  }

`;
const EMPLOYEE_STRUCTURE_MUTATION = `
   mutation createEmployeeSalery(
        $user: String!,
        $annualCtc: String!,
        $monthlyCtc: String!,
        $structureName:String!,
        $taxSlab: String!,
        $basicPay:String!,
        $monthlyBasicPay: String!,
        $grossAmount:String!,
        $monthlyGrossAmount: String!,
        $specialAllowance:String!,
        $monthlySpecialAllowance: String!,
        $totalBenefits:String!,
        $monthlyTotalBenefits: String!,
        $netAmount:String!,
        $monthlyNetAmount: String!,
        $totalDeductions: String!,
        $monthlyTotalDeductions : String!, 
)
    {
    AddEmployeeSalery(input:{
        user:$user, 
        annualCtc:$annualCtc, 
        monthlyCtc : $monthlyCtc
        structureName: $structureName, 
        taxSlab:$taxSlab, 
        basicPay:$basicPay, 
        monthlyBasicPay : $monthlyBasicPay
        grossAmount: $grossAmount, 
        monthlyGrossAmount : $monthlyGrossAmount
        specialAllowance: $specialAllowance,
        monthlySpecialAllowance : $monthlySpecialAllowance    
        totalBenefits: $totalBenefits, 
        monthlyTotalBenefits : $monthlyTotalBenefits
        netAmount:$netAmount, 
        monthlyNetAmount : $monthlyNetAmount
        totalDeductions: $totalDeductions,
        monthlyTotalDeductions : $monthlyTotalDeductions
    }){
        EmployeeSalerydetails{
            id
        }
    }
    }
`;

const EMPLOYEE_STRUCTURE_MUTATION_EDB = `
    mutation salery_structureEDR(
    $employee_salery: String!,
    $types: String!,
    $component_name: String!,
    $calculated_from: String!,
    $percentage:Int!,
    $amount:Int!,
    $yearly_amount:Int!,
    $monthly_amount:Int!,
    $calculatedIn:String!){
    AddEmployeeSaleryEdr(input:{
        employeeSalery:$employee_salery,
        types:$types,
        componentName:$component_name,
        calculatedFrom: $calculated_from,
        calculatedIn:$calculatedIn,
        percentage:$percentage,
        amount:$amount,
        yearlyAmount:$yearly_amount,
        monthlyAmount:$monthly_amount
    }){
        status
    }
    }
`;

const AddEmployeeSalary = () => {
  const navigate = useNavigate();
   const {AccessData,Empdisplay,showemp,setshowemp} = useUserDetails()
    const [pageState, setPageState] = useState({
       loading: false,
       error: false,
       message: "",
       state: "init",
     });
  const [userData, setUserData] = useState([]);
  const [salaryStructureData, setSalaryStructureData] = useState([]);
  const [assignedUsers, setAassignedUsers] = useState([]);
  const [uniqueSalaryStructures, setUniqueSalaryStructures] = useState([]);
   const [editdisplay,seteditdisplay] = useState(false)
  const [structureData, setStructureData] = useState({
    employeeName: "",
    employeeNameStatus: "",
    salaryStructure: "",
    salaryStructureStatus: "",
    annualCtc: "",
    annualCtcStatus: "",
    basicpercentage: "",
    basicpercentageStatus: "",
    taxSlab: "",
    taxSlabStatus: "",
    totalDeductions: "",
    yearlyNetSalary: "",
    monthlyNetSalary: "",
  });
  const [originaldata,setoriginaldata] = useState({
    employeeName: "",
    employeeNameStatus: "",
    salaryStructure: "",
    salaryStructureStatus: "",
    annualCtc: "",
    annualCtcStatus: "",
    basicpercentage: "",
    basicpercentageStatus: "",
    taxSlab: "",
    taxSlabStatus: "",
    totalDeductions: "",
    yearlyNetSalary: "",
    monthlyNetSalary: "",
  })
  const[Alldata,setAlldata] = useState([])
  const [Earninglist,setEarninglist] = useState([])
  const [Deductionlist,setDeductionlist] = useState([])
  const [Benefits,setBenefits] = useState([])

  const EarningListTable = {
    columns: [
      {
        field: "id",
        headerName: "S No",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "componentName",
        headerName: "Component",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      // {
      //   field: "calculatedFrom",
      //   headerName: "Calculated From",
      //   flex: 1,
      //   editable: false,
      //   disableColumnMenu: true,
      //   sortable: true,
      // },
      {
        field: "percentage",
        headerName: "Percentage",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "amount",
        headerName: "Amount",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "monthly",
        headerName: "Monthly",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "yearly",
        headerName: "Yearly",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
    ],
   

    rows: Earninglist?.map((leave,index) => ({
      id: index + 1,
      componentName: leave.componentName,
      percentage: leave.percentage,
      amount: leave.amount,
      monthly: leave.monthly,
      yearly: leave.yearly,
    })),

  };
  const SalaryList = {
    columns: [
      {
        field: "id",
        headerName: "S No",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
        {
        field: "Component",
        headerName: "Component",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
        {
        field: "Amount",
        headerName: "Month",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      }
    ],
   

    // rows:  Alldata.map((leave, index) => ({
    //   id: index + 1,
    //   ctc: leave.ctc,
    //   gross: leave.gross,
    //   totalDeductions: leave.totalDeductions,
    //   totalBenefits: leave.totalBenefits,
    //   netPay: leave.netPay,
    //   overallSum: leave.overallSum,
    //   difference: leave.difference,
    // })),

    rows:  Alldata.map((leave, index) => ({
      id: index + 1,
      Component : leave.Component,
      Amount:leave.Amount,
   
    })),
    

  };

  
  const DeductionListTable = {
    columns: [
      {
        field: "id",
        headerName: "S No",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "componentName",
        headerName: "Component",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      // {
      //   field: "calculatedFrom",
      //   headerName: "Calculated From",
      //   flex: 1,
      //   editable: false,
      //   disableColumnMenu: true,
      //   sortable: true,
      // },
      {
        field: "percentage",
        headerName: "Percentage",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "amount",
        headerName: "Amount",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "monthly",
        headerName: "Monthly",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "yearly",
        headerName: "Yearly",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
    ],
    // rows: structureData.salaryStructure?.value
    //   ? salaryStructureData
    //       .filter(
    //         (structure) =>
    //           structure.structureName ===
    //             structureData.salaryStructure?.value &&
    //           structure.structureType === "Deduction"
    //       )
    //       .map((structure, index) => {
    //         return {
    //           id: structure.id,
    //           sNo: index + 1,
    //           componentName: structure.component?.componentName,
    //           calculatedFrom: structure.component?.calculatedFrom,
    //           percentage: structure.percentage,
    //           amount: structure.amount,
    //         };
    //       })
    //   : [],
    rows: Deductionlist?.map((leave,index) => ({
      id: index + 1,
      componentName: leave.componentName,
      percentage: leave.percentage,
      amount: leave.amount,
      monthly: leave.monthly,
      yearly: leave.yearly,
    })),
  };
  const BenifitsListTable = {
    columns: [
      {
        field: "id",
        headerName: "S No",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "componentName",
        headerName: "Component",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      // {
      //   field: "calculatedFrom",
      //   headerName: "Calculated From",
      //   flex: 1,
      //   editable: false,
      //   disableColumnMenu: true,
      //   sortable: true,
      // },
      {
        field: "percentage",
        headerName: "Percentage",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "amount",
        headerName: "Amount",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "monthly",
        headerName: "Monthly",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "yearly",
        headerName: "Yearly",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
    ],
    // rows: structureData.salaryStructure?.value
    //   ? salaryStructureData
    //       .filter(
    //         (structure) =>
    //           structure.structureName ===
    //             structureData.salaryStructure?.value &&
    //           structure.structureType === "Benifits"
    //       )
    //       .map((structure, index) => {
    //         return {
    //           id: structure.id,
    //           sNo: index + 1,
    //           componentName: structure.component?.componentName,
    //           calculatedFrom: structure.component?.calculatedFrom,
    //           percentage: structure.percentage,
    //           amount: structure.amount,
    //         };
    //       })
    //   : [],
    rows: Benefits?.map((leave,index) => ({
      id: index + 1,
      componentName: leave.componentName,
      percentage: leave.percentage,
      amount: leave.amount,
      monthly: leave.monthly,
      yearly: leave.yearly,
    })),
  };


  const [iddata,setiddata] = useState('')
  const [basicdisable,setbasicdisable] = useState(true)
  useEffect(() => {
    if (iddata) {
      fetchdata(iddata);
    }
  }, [iddata]);
  


  const fetchdata = async (id)=>{
    const query = `query getSalaryStructureById($id: String!) {
  salaryStructuresById(id: $id) {
    id
    structureName
    components {
      id
      percentage
      amount
      type
        componentName
      }
    }
  }`

  try {
    const variables = { id };

    // Make the Axios POST request to the GraphQL API
    const response = await axios.post(BASEURL, {
      query,
      variables,
    });

    const alldata = response.data.data.salaryStructuresById.components;

    const earning = alldata.filter((val) => val.type == "Earnings");
    const deductions = alldata.filter((val) => val.type == "Deductions");
    const benefits = alldata.filter((val) => val.type == "Benefits");

   let componentname = earning.filter((data)=>data.componentName == 'BASIC')

    let percentagedata = componentname[0]?.percentage

    // setbasicdisable(true)
    setStructureData({
      ...structureData,
      basicpercentage: Math.trunc(percentagedata)
    })
    
  } catch (error) {
    setConfirmationDialog({
      open: true,
      title: "Error massage",
      message:
        "Sorry for your inconvieeeeeence, there is some issue in our network. Please try again later.",
      showCancel: true,
      showConfirm: false,

      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  }

   
  
  }

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
    const[id,setid] = useState('')
   useEffect(() => {
      const queryParams = new URLSearchParams(window.location.search);
      const id = queryParams.get("id");
      setid(id);
      if (id) {
        getempiddata(id);
      }else{
         setPageState((prevState) => ({
                ...prevState,
                loading: false,
                state: "default",
              }));
      }
    }, []);

  const SalaryStructureOptions = uniqueSalaryStructures.map((sal) => {
    return {
      value: sal.structureName,
      label: sal.structureName,
      id:sal.id
    };
  });

  const userOptions = userData
    .filter((user) => !assignedUsers.some((val) => val?.user?.id === user.id))
    .map((user) => ({
      value: user.id,
      label: user.username,
    }));
  // .sort((a, b) => a.label.localeCompare(b.label));


  const textSlabOptions = [
    { value: "Slab 1", label: "Slab 1" },
    { value: "Slab 2", label: "Slab 2" },
    { value: "Slab 3", label: "Slab 3" },
  ];
  
  const fetchUserDetails = async () => {
    const response = await fetch(BASEURL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query: All_USER_Query }),
    });
    const data = await response.json();
    const usersWithDecodedIds = decodeBase64IdSS(data.data.allUsersDetail);
    
    if (data.errors) {
      throw new Error(data.errors[0].message);
    }
    return data.data.allUsersDetail;
  };


  const decodeBase64IdSS = (data) => {
    
    return data.map((user) => {
      try {
        // Decode the Base64 `id` value
        const decodedString = atob(user.id); // Decode Base64 string
  
        // Extract the part after the prefix (e.g., 'CustomUserView:')
        const decodedId = decodedString.split(":").pop(); // Take the last part after the colon
        
        // Return updated object with the decoded ID
        return { ...user, decodedId };
      } catch (error) {
        console.error("Error decoding ID:", user.id, error);
        return { ...user, decodedId: "Invalid Base64" };
      }
    });
  };

  const fetchUserAlreadyAssignedUser = async () => {
    const response = await fetch(BASEURL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query: ALL_ASSIGNED_USER }),
    });
    const data = await response.json();

    if (data.errors) {
      throw new Error(data.errors[0].message);
    }
    return data.data.allEmployeeSalery;
  };

  const fetchSalaryStructure = async () => {
    const response = await fetch(BASEURL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query: ALL_SALARY_STRUCTURE }),
    });
    const data = await response.json();

    if (data.errors) {
      throw new Error(data.errors[0].message);
    }
    return data.data.salaryStructures;
  };

  const CalculatedSalary = () => {
    // Component of Earning, Deduction, and Benefits
    const EARNING = salaryStructureData
      .filter(
        (structure) =>
          structure.structureType === "Earning" &&
          structure.structureName === structureData.salaryStructure?.value
      )
      .map((structure) => ({
        id: structure.id,
        payrollFrequency: structure.payrollFrequency,
        amount: structure.amount,
        percentage: structure.percentage,
        component: structure.component?.componentName,
        calculatedFrom: structure.component?.calculatedFrom,
        calculatedIn: structure.component?.calculatedIn,
        structureName: structure.structureName,
        structureType: structure.structureType,
      }));

    const DEDUCTION = salaryStructureData
      .filter(
        (structure) =>
          structure.structureType === "Deduction" &&
          structure.structureName === structureData.salaryStructure?.value
      )
      .map((structure) => ({
        id: structure.id,
        payrollFrequency: structure.payrollFrequency,
        amount: structure.amount,
        percentage: structure.percentage,
        component: structure.component?.componentName,
        calculatedFrom: structure.component?.calculatedFrom,
        calculatedIn: structure.component?.calculatedIn,
        structureName: structure.structureName,
        structureType: structure.structureType,
      }));

    const BENEFITS = salaryStructureData
      .filter(
        (structure) =>
          structure.structureType === "Benifits" &&
          structure.structureName === structureData.salaryStructure?.value
      )
      .map((structure) => ({
        id: structure.id,
        payrollFrequency: structure.payrollFrequency,
        amount: structure.amount,
        percentage: structure.percentage,
        component: structure.component?.componentName,
        calculatedFrom: structure.component?.calculatedFrom,
        calculatedIn: structure.component?.calculatedIn,
        structureName: structure.structureName,
        structureType: structure.structureType,
      }));

    // Initial Calculations
    const CTC = structureData.annualCtc;
    const BASIC = Number(structureData.annualCtc) / 2;
    let CALCULATED_EARNING = [];
    let CALCULATED_DEDUCTION = [];
    let CALCULATED_BENIFITS = [];

    // Function to calculate Sum, Deductions, Benefits based on Special Allowance
    const calculateValues = (specialAllowance) => {
      let grossEarnings = BASIC + specialAllowance;
      let totalDeductions = 0;
      let totalBenefits = 0;

      // Calculate Earning Components
      CALCULATED_EARNING = EARNING.map((earnings) => {
        let amount = 0;
        if (earnings.calculatedIn === "percentage") {
          if (earnings.calculatedFrom === "CTC") {
            amount = (earnings.percentage / 100) * CTC;
          } else if (earnings.calculatedFrom === "Basic") {
            amount = (earnings.percentage / 100) * BASIC;
          } else if (earnings.calculatedFrom === "Gross") {
            amount = (earnings.percentage / 100) * grossEarnings;
          }
        } else if (earnings.calculatedIn === "amount") {
          amount = earnings.amount;
        }
        grossEarnings += amount;
        return {
          employeeSalaryComponent: earnings.component,
          calculatedFrom: earnings.calculatedFrom,
          calculatedIn: earnings.calculatedIn,
          percentage: earnings.percentage,
          amount: earnings.amount,
          type: earnings.structureType,
          yearlyAmount: amount,
          monthlyAmount: amount / 12,
        };
      });

      // Calculate Deductions
      CALCULATED_DEDUCTION = DEDUCTION.map((deduction) => {
        let amount = 0;
        if (deduction.calculatedIn === "percentage") {
          if (deduction.calculatedFrom === "CTC") {
            amount = (deduction.percentage / 100) * CTC;
          } else if (deduction.calculatedFrom === "Basic") {
            amount = (deduction.percentage / 100) * BASIC;
          } else if (deduction.calculatedFrom === "Gross") {
            amount = (deduction.percentage / 100) * grossEarnings;
          }
        } else if (deduction.calculatedIn === "amount") {
          amount = deduction.amount;
        }
        totalDeductions += amount;
        return {
          employeeSalaryComponent: deduction.component,
          calculatedFrom: deduction.calculatedFrom,
          calculatedIn: deduction.calculatedIn,
          percentage: deduction.percentage,
          amount: deduction.amount,
          type: deduction.structureType,
          yearlyAmount: amount,
          monthlyAmount: amount / 12,
        };
      });

      // Calculate Benefits
      CALCULATED_BENIFITS = BENEFITS.map((benefits) => {
        let amount = 0;
        if (benefits.calculatedIn === "percentage") {
          if (benefits.calculatedFrom === "CTC") {
            amount = (benefits.percentage / 100) * CTC;
          } else if (benefits.calculatedFrom === "Basic") {
            amount = (benefits.percentage / 100) * BASIC;
          } else if (benefits.calculatedFrom === "Gross") {
            amount = (benefits.percentage / 100) * grossEarnings;
          }
        } else if (benefits.calculatedIn === "amount") {
          amount = benefits.amount;
        }
        totalBenefits += amount;
        return {
          employeeSalaryComponent: benefits.component,
          calculatedFrom: benefits.calculatedFrom,
          calculatedIn: benefits.calculatedIn,
          percentage: benefits.percentage,
          amount: benefits.amount,
          type: benefits.structureType,
          yearlyAmount: amount,
          monthlyAmount: amount / 12,
        };
      });

      const Sum = grossEarnings + totalBenefits;
      const NetSalary = grossEarnings - totalDeductions;
      const Difference = CTC - Sum;

      return {
        Sum,
        NetSalary,
        Difference,
        grossEarnings,
        totalDeductions,
        totalBenefits,
      };
    };

    // Implement Goal Seek - Adjust Special Allowance
    const goalSeek = () => {
      let specialAllowance = 0;
      let result = calculateValues(specialAllowance);

      // Continue adjusting Special Allowance until the Difference is close to zero
      while (Math.abs(result.Difference) > 0.001) {
        specialAllowance += result.Difference; // Adjust based on the current difference
        result = calculateValues(specialAllowance);
      }

      return { specialAllowance, ...result };
    };

    const {
      specialAllowance,
      Sum,
      NetSalary,
      Difference,
      grossEarnings,
      totalDeductions,
      totalBenefits,
    } = goalSeek();
    const All_Calculated_Details = [
      ...CALCULATED_EARNING.map((val) => {
        return {
          ...val,
          yearlyAmount: Math.round(val.yearlyAmount),
          monthlyAmount: Math.round(val.monthlyAmount),
        };
      }),
      ...CALCULATED_BENIFITS.map((val) => {
        return {
          ...val,
          yearlyAmount: Math.round(val.yearlyAmount),
          monthlyAmount: Math.round(val.monthlyAmount),
        };
      }),
      ...CALCULATED_DEDUCTION.map((val) => {
        return {
          ...val,
          yearlyAmount: Math.round(val.yearlyAmount),
          monthlyAmount: Math.round(val.monthlyAmount),
        };
      }),
    ];

    setStructureData({
      ...structureData,
      monthlyCtc: Math.round(CTC / 12),
      basicSalary: Math.round(BASIC),
      monthlyBasicSalary: Math.round(BASIC / 12),
      grossSalary: Math.round(grossEarnings),
      monthlyGrossSalary: Math.round(grossEarnings / 12),
      totalDeductions: Math.round(totalDeductions),
      monthlyTotalDeductions: Math.round(totalDeductions / 12),
      totalBenefits: Math.round(totalBenefits),
      monthlyTotalBenefits: Math.round(totalBenefits / 12),
      specialAllowance: Math.round(specialAllowance),
      monthlySpecialAllowance: Math.round(specialAllowance / 12),
      yearlyNetSalary: Math.round(NetSalary),
      monthlyNetSalary: Math.round(NetSalary / 12),
      EDR: All_Calculated_Details,
    });
  };

  useEffect((_) => {
    const fetchData = async () => {
      try {
        const userDetails = await fetchUserDetails();
        const SalaryStructureDetails = await fetchSalaryStructure();
        // const AssignedUsers = await fetchUserAlreadyAssignedUser();
        const uniqueStructures = SalaryStructureDetails.filter(
          (item, index, self) =>
            index ===
            self.findIndex(
              (obj) =>
                obj.structureName === item.structureName &&
                obj.payrollFrequency === item.payrollFrequency
            )
        ).map((item) => ({
          id: item.id,
          structureName: item.structureName,
          payrollFrequency: item.payrollFrequency,
        }));
        debugger;
        // setAassignedUsers(AssignedUsers)
        setSalaryStructureData(SalaryStructureDetails);
        setUniqueSalaryStructures(uniqueStructures);
        setUserData(userDetails);
      } catch (error) {
        console.error("Error fetching components: ", error);
      }
    };
    fetchData();
  }, []);

  

  useEffect(() => {
    if (structureData.salaryStructure?.value && structureData.annualCtc) {
      CalculatedSalary();
    } else if (structureData.salaryStructure == null) {
      setStructureData({
        ...structureData,
        totalDeductions: "",
        yearlyNetSalary: "",
        monthlyNetSalary: "",
      });
    }
  }, [structureData.salaryStructure, structureData.annualCtc]);

  const handleStructureDataChange = (event, selectEvent) => {
    let updatedStructureData = { ...structureData };
  
    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "employeeName") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          updatedStructureData[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          updatedStructureData[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
     
      if (selectEvent.name === "salaryStructure") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        let data = event?.id
        setiddata(data)
        if (lengthRegex.test(event?.label) === true) {
          updatedStructureData[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          updatedStructureData[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      updatedStructureData[selectEvent.name] = event; // Update the dropdown value
    } else if (event?.target) {
      // Handle text input changes
      const { name, value } = event.target;
  
      switch (name) {
        case "annualCtc": {
          const lengthRegex = /^\d+$/; // Allow only numbers
          updatedStructureData["annualCtcStatus"] = 
            lengthRegex.test(value) 
              ? "success" 
              : value === "" 
                ? "unchecked" 
                : "error";
          break;
        }
        case "basicpercentage": 
        // {
        //   const lengthRegex = /^\d*\.?\d+$/; // Allow numbers and floats
        //   updatedStructureData["basicpercentageStatus"] = 
        //     lengthRegex.test(value) 
        //       ? "success" 
        //       : value === "" 
        //         ? "unchecked" 
        //         : "error";
        //   break;
        // }
        {
          const lengthRegex = /^\d*\.?\d+$/;
          // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');

          if (lengthRegex.test(event.target.value?.trim())) {
            updatedStructureData[event.target.name + "Status"] = "success";
          } else {
            updatedStructureData[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
        }
        break;
        default:
          break;
      }
      updatedStructureData[name] = value; // Update the input value
    }
  
    setStructureData(updatedStructureData); // Update the state
  };
  
  // const handleStructureDataChange = (event, selectEvent) => {
  //   setStructureData((prevState) => {
  //     const updatedState = { ...prevState };
  //     let structureState = { ...structureData };

  //     // Handle dropdown changes
  //     if (event?.target === undefined && selectEvent) {
  //       const dropdownValue = event?.label || "";
  //       const isValid = /^[A-Za-z 0-9]+$/.test(dropdownValue);
  
  //       updatedState[selectEvent.name] = dropdownValue; // Update dropdown value
  //       updatedState[`${selectEvent.name}Status`] = dropdownValue
  //         ? isValid
  //           ? "success"
  //           : "error"
  //         : "unchecked";
  //     }
  //     // Handle input fields
  //     else {
  //       const { name, value } = event.target;
  
  //       switch (name) {
  //         case "annualCtc":
  //         case "basicpercentage": {
  //           const isValid = /^\d+$/.test(value); // Allow only numbers
  //           updatedState[name] = value; // Update input value
  //           updatedState[`${name}Status`] = value
  //             ? isValid
  //               ? "success"
  //               : "error"
  //             : "unchecked";
  //           break;
  //         }
  //         default:
  //           updatedState[name] = value; // Default case to handle other inputs
  //           break;
  //       }
  //     }
  
  //     return updatedState; // Return the updated state
  //   });
  // };
  


  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      structureData.employeeNameStatus === "success" &&
      structureData.salaryStructureStatus === "success" &&
      structureData.annualCtcStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleAddComponent = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to submit your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onComponentSubmit();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDeleteEMP();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onDeleteEMP = async () => {
    const query = `
       mutation deleteEmployeesalary($userEmployeesalaryId:ID!){
  deleteEmployeesalary(id:$userEmployeesalaryId) {
    success
  }
}
        `;

    try {
      const response = await axios.post(BASEURL, {
        query: query,
        variables: {
          userEmployeesalaryId: id, // Corrected variable name
        },
      });

      const responseData = response.data;


      if (responseData.data.deleteEmployeesalary.success) {
        navigate("/employee-salary");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "EmployeeSalary Deleted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
      } else {
      }
    } catch (error) {
      console.error("An error occurred while deleting the wfh:", error);
    }
  };

  // Helper function to create EmployeeEDBData
  const createEmployeeEDBData = (edb, responseId) => ({
    employee_salery: responseId,
    types: edb.type,
    component_name: edb.employeeSalaryComponent,
    calculated_from: edb.calculatedFrom,
    percentage: edb.percentage,
    amount: edb.amount,
    yearly_amount: edb.yearlyAmount,
    monthly_amount: edb.monthlyAmount,
    calculatedIn: edb.calculatedIn,
  });

  // Helper function to submit EDB data
  const submitEDBData = async (employeeEDBData) => {
    try {
      const edbResponse = await request(
        BASEURL,
        EMPLOYEE_STRUCTURE_MUTATION_EDB,
        employeeEDBData
      );
      return edbResponse; // Success message
    } catch (error) {
      console.error("Error submitting EDB data:", error);
      throw error; // Throw error to handle it later
    }
  };


  const decodeBase64Id = (base64Id) => {
    try {
      const decodedString = atob(base64Id); // Decode the Base64 string
      const parts = decodedString.split(":"); // Split by delimiter (e.g., ":")
      return parts[1]; // Return the numeric part
    } catch (error) {
      console.error("Error decoding Base64 ID:", error);
      return null;
    }
  };
  
  const getiddata = (value)=>{
  let alldata =  salaryStructureData.filter((val)=>val.structureName == value)
  let result = alldata[0].id
  return result
  }


  const getempiddata = async(id)=>{
      setPageState({
          ...pageState,
          loading: true,
          state: "init",
        });
    const query =`query EmployeesalaryById($id: String!) {
  employeeCalcualtedsalaryId(id: $id) {
    id
    ctc
    gross
    totalDeductions
    totalBenefits
    netPay
    overallSum
    difference
    basicPercentage
    salaryStructure {
      id
      structureName
    }
    user {
      id
      firstName
      lastName
      empid
    }
    breakdown {
      type
      componentName
      percentage
      monthly
      yearly
    }
  }
}`

   try {

    const response = await axios.post(
      BASEURL,
      {
        query: query,
        variables: { id },
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )

    let result = response.data.data.employeeCalcualtedsalaryId
    const salaryDetails = response.data.data.employeeCalcualtedsalaryId.breakdown;
    let earningdata = salaryDetails.filter((val)=> val.type == 'Earnings')
    setEarninglist(earningdata)
    
    let deductiondata = salaryDetails.filter((val)=>val.type =='Deductions')
    setDeductionlist(deductiondata)
    let benefitsdata = salaryDetails.filter((val)=>val.type =='Benefits')
    setBenefits(benefitsdata)
    const filterdata = userData.filter((val)=>val.id == result.user.id)
    const amount = parseFloat((result.ctc / 12).toFixed(2));
    const salaryArray = [
      {
        "Component": "CTC",
        "Amount":amount ,
      
      },
      {
        "Component": "Gross",
        "Amount":result.gross, 
       
      },
      {
        "Component": "Total Deductions",
        "Amount":result.totalDeductions, 
       
      },
      {
        "Component": "Total Benefits",
        "Amount":result.totalBenefits, 
       
      },
      {
        "Component": "Net Pay",
        "Amount":result.netPay, 
       
      },
      {
        "Component": "OverallSum",
        "Amount":result.overallSum, 
       
      },
      {
        "Component": "Difference",
        "Amount":result.difference, 
      
      },
   ];


  setAlldata(salaryArray)
    setStructureData((prevState) => ({
      ...prevState,
      employeeName: {
        value: result.user?.id, 
        label: `${result.user?.firstName} (${result.user?.empid})`, 
      },
      annualCtc: result.ctc,
      basicpercentage: Math.trunc(result.basicPercentage),
      salaryStructure: { value: result.salaryStructure?.id, label: result.salaryStructure?.structureName },
    }));
    
   
    setoriginaldata(({
      ...structureData,
      
      employeeName: {
        value: result.user?.id, 
        label: `${result.user?.firstName} (${result.user?.empid})`, 
      },
      annualCtc: result.ctc,
      basicpercentage: result.basicPercentage,
      salaryStructure: { value: result.salaryStructure.id, label: result.salaryStructure.structureName },
    }))

   setPageState((prevState) => ({
          ...prevState,
          loading: false,
          state: "default",
        }));
    
   } catch (error) {
    setPageState((prevState) => ({
      ...prevState,
      loading: false,
      state: "default",
    }));
   }
  }

  const onComponentSubmit = async () => {
    const query = `
    mutation calculateEmployeeSalary($customeUserId:ID!,$salaryStructureId:ID!,$ctc:Float!,$basicPercentage:Float!){
  calculateEmployeeSalary(customUserId:$customeUserId,salaryStructureId:$salaryStructureId, ctc:$ctc,basicPercentage:$basicPercentage) {
    ctc
    gross
    totalDeductions
    totalBenefits
    netPay
    overallSum
    difference
    breakdown {
      type
      componentName
      percentage
      monthly
      yearly
    }
  }
}
    `;
  
    const variables = {
      customeUserId: decodeBase64Id(structureData.employeeName.value),
      salaryStructureId: getiddata(structureData.salaryStructure.value),
      ctc: Number(structureData.annualCtc), // Ensure ctc is a number
      basicPercentage: Number(structureData.basicpercentage), // Ensure percentage is a number
    };
    
    try {
      const response = await axios.post(BASEURL, {
        query,
        variables,
      });
  
      if (response.data.errors) {
        throw new Error(response.data.errors[0].message);
      }
  
      // Handle success
      const salaryDetails = response.data.data.calculateEmployeeSalary.breakdown;
      const salaryD = response.data.data.calculateEmployeeSalary;
      // const salaryArray = [{

  
       const salaryArray = [
          {
            "Component": "CTC",
            "Amount":salaryD.ctc ,
          
          },
          {
            "Component": "Gross",
            "Amount":salaryD.gross, 
           
          },
          {
            "Component": "Total Deductions",
            "Amount":salaryD.totalDeductions, 
           
          },
          {
            "Component": "Total Benefits",
            "Amount":salaryD.totalBenefits, 
           
          },
          {
            "Component": "Net Pay",
            "Amount":salaryD.netPay, 
           
          },
          {
            "Component": "OverallSum",
            "Amount":salaryD.overallSum, 
           
          },
          {
            "Component": "Difference",
            "Amount":salaryD.difference, 
          
          },
       ];
  
      setAlldata(salaryArray)
      // if (Array.isArray(salaryD)) {
      //   setAlldata(salaryD);
      // } else {
      //   console.error("Expected array, but got:", salaryD);
      // }
      
  
      let earningdata = salaryDetails.filter((val)=> val.type == 'Earnings')
      setEarninglist(earningdata)
      let deductiondata = salaryDetails.filter((val)=>val.type =='Deductions')
      setDeductionlist(deductiondata)
      let benefitsdata = salaryDetails.filter((val)=>val.type =='Benefits')
      setBenefits(benefitsdata)
    
     
      // Update the state or navigate to a success page as needed
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });

      if(response.data.data.calculateEmployeeSalary){
        Swal.fire({
          position: "center",
          icon: "success",
          title: "EmployeeSalary Created Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        // navigate('/employee-salary')
      }
  
      // Uncomment the following line to navigate:
      // navigate("/calculated-salary-details", { state: { salaryDetails } });
    } catch (error) {
      console.error("Error in API response:", error.response?.data || error.response?.data );
  
      // Show error dialog
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:error.message,
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };
  
 const Updateempolyeesalary = async()=>{
  const query = `mutation UpdateEmployeeSalary (
$userEmployeesalaryId:ID!,
$customeUserId:ID!,
$salaryStructureId:ID!,
$ctc:Float!,
$basicPercentage:Float!){
     updateEmployeesalary(
    userEmployeesalaryId: $userEmployeesalaryId
    salaryStructureId: $salaryStructureId
    ctc: $ctc
    basicPercentage: $basicPercentage
    customUserId: $customeUserId
  ) {
    ctc
    gross
    totalDeductions
    totalBenefits
    netPay
    overallSum
    difference
    user{
    username
    }
  }
}
 `
 const variables = {
  userEmployeesalaryId: id,
  customeUserId: decodeBase64Id(structureData.employeeName.value),
  salaryStructureId: getiddata(structureData.salaryStructure.label),
  ctc: Number(structureData.annualCtc), // Ensure ctc is a number
  basicPercentage: Number(structureData.basicpercentage), // Ensure percentage is a number
};


 try {
  const response = await axios.post(BASEURL, {
    query,
    variables,
  });
  
  if(response.data.data.updateEmployeesalary){
    Swal.fire({
      position: "center",
      icon: "success",
      title: "EmployeeSalary Updated Successfully!",
      showConfirmButton: false,
      timer: 2500,
    });
    // navigate('/employee-salary')
  }
} catch (error) {
  console.error("Error in API response:", error.response?.data || error.message);

  // Show error dialog
  setConfirmationDialog({
    open: true,
    title: "Error message",
    message:
      "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
    showCancel: true,
    showConfirm: false,
    onCancel: () => {
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
    },
  });
}
 }
  

 const onDiscardDesignation = () => {
  if (originaldata) {
    setStructureData(originaldata); // Reset to original data
  }
  seteditdisplay(false);
  setshowemp(true)
};
  
const toggleEdit = ()=>{
  seteditdisplay(true)
  setshowemp(false)
}

  

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
        {pageState.state === "init" ? (
        <Card>
          <MaterialBox>
            <MaterialBox
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                height: "74vh",
                margin: "auto",
              }}
            >
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                spacing={2}
                padding={10}
              >
                <Grid size={{ xs: 6, sm: 6 }}>
                  <MaterialTypography variant="body2" mb={3}>
                    Please wait while we fetch the Employee salary details for you. This may
                    take a few seconds.
                  </MaterialTypography>
                  <MaterialBox
                    style={{
                      overflow: "hidden",
                      borderRadius: 5,
                      height: 24,
                    }}
                  >
                    <LinearProgress
                      size="lg"
                      color="dark"
                      thickness={16}
                      style={{
                        borderRadius: 5,
                        height: 16,
                        maxHeight: 16,
                      }}
                      sx={{
                        "& .MuiLinearProgress-bar": {
                          height: 16,
                        },
                      }}
                    />
                  </MaterialBox>
                </Grid>
              </Grid>
            </MaterialBox>
          </MaterialBox>
        </Card>
      ) : (
      <Card sx={{ overflow: "visible" }}>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Add Employee Salary Details
                </MaterialTypography>
              </Stack>
              {Empdisplay && (
                 <ButtonGroup
                 variant="outlined"
                 aria-label="Loading button group"
               >
                 <MaterialButton
                   variant="gradient"
                   color="dark"
                   onClick={toggleEdit}
                   startIcon={<EditIcon />}
                 >
                   Edit
                 </MaterialButton>
                 {/* Uncomment to enable delete functionality */}
                 
     <MaterialButton
         variant="gradient"
         color="dark"
         onClick={AddDelete}
         startIcon={<DeleteIcon />}
     >
         Delete
     </MaterialButton>
    
               </ButtonGroup>
              )}
            </Stack>
          }
        />
        <CardContent>
          <MaterialBox>
            <Grid container spacing={1}>
              <Grid size={{ xs: 6, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Employee Name <span style={{color:"red"}}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="employeeName"
                  value={structureData.employeeName}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleStructureDataChange}
                  options={userData.map((user) => ({
                    value: user.id,
                    label: user.firstName
                      ? `${user.firstName.toUpperCase()} (${user.empid})`
                      : user.empid, // Fallback for missing data
                  }))}
                  error={structureData.employeeNameStatus === "uncheckedError"}
                  success={structureData.employeeNameStatus === "success"}
                  isDisabled={showemp}

                  isClearable
                />

                {structureData.employeeNameStatus === "uncheckedError" && (
                  <FormControl error>
                    <FormHelperText>Employee Name is required</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 6, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Salary Structure <span style={{color:"red"}}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="salaryStructure"
                  isDisabled={showemp}
                  value={structureData.salaryStructure}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleStructureDataChange}
                  options={SalaryStructureOptions.map((value) => {
                    return {
                      value: value.value,
                      label: value.label,
                      id:value.id
                    };
                  })}
                  error={
                    structureData.salaryStructureStatus === "uncheckedError"
                      ? true
                      : false
                  }
                  success={
                    structureData.salaryStructureStatus === "success"
                      ? true
                      : false
                  }
                  isClearable
                />
                {structureData.salaryStructureStatus === "uncheckedError" && (
                  <FormControl error>
                    <FormHelperText>
                      Salary Structure is required
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 6, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Annual CTC <span style={{color:"red"}}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="annualCtc"
                  placeholder="Eg.300000"
                  value={structureData.annualCtc}
                  onChange={handleStructureDataChange}
                  disabled={showemp}
                  error={
                    structureData.annualCtcStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    structureData.annualCtcStatus === "success" ? true : false
                  }
                />
                {structureData.annualCtcStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Annual CTC must contain only numbers</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 6, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Basic Percentage <span style={{color:"red"}}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="basicpercentage"
                  // placeholder="Eg.300000"
                  disabled={basicdisable}
                  value={structureData.basicpercentage}
                  onChange={handleStructureDataChange}
                  error={
                    structureData.basicpercentageStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    structureData.basicpercentageStatus === "success"
                      ? true
                      : false
                  }
                />
                {structureData.basicpercentageStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Basic Percentage must contain only numbers
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>

              {/* <Grid size={{ xs: 5, sm: 3 }}>
                                <MaterialBox lineHeight={0} display="inline-block">
                                    <MaterialTypography
                                        component="label"
                                        variant="caption"
                                        fontWeight="bold"
                                    >
                                        Tax Slab
                                    </MaterialTypography>
                                </MaterialBox>
                                <MaterialSelect
                                    name="taxSlab"
                                    value={structureData.taxSlab}
                                    customStyles={{ optionPadding: 20 }}
                                    onChange={handleStructureDataChange}
                                    options={textSlabOptions.map((value) => {
                                        return {
                                            value: value.value,
                                            label: value.label
                                        }
                                    })}
                                    success={structureData.taxSlabStatus === "success" ? true : false}
                                    isClearable
                                />
                            </Grid>
                            <Grid size={{ xs: 5, sm: 3 }}>
                                <MaterialBox lineHeight={0} display="inline-block">
                                    <MaterialTypography
                                        component="label"
                                        variant="caption"
                                        fontWeight="bold"
                                    >
                                        Total Deductions
                                    </MaterialTypography>
                                </MaterialBox>
                                <MaterialInput
                                    disabled
                                    value={structureData.totalDeductions}
                                />
                            </Grid>
                            <Grid size={{ xs: 5, sm: 3 }}>
                                <MaterialBox lineHeight={0} display="inline-block">
                                    <MaterialTypography
                                        component="label"
                                        variant="caption"
                                        fontWeight="bold"
                                    >
                                        Net Salary Year
                                    </MaterialTypography>
                                </MaterialBox>
                                <MaterialInput
                                    disabled
                                    value={structureData.yearlyNetSalary}
                                />
                            </Grid>
                            <Grid size={{ xs: 5, sm: 3 }}>
                                <MaterialBox lineHeight={0} display="inline-block">
                                    <MaterialTypography
                                        component="label"
                                        variant="caption"
                                        fontWeight="bold"
                                    >
                                        Net Salary Month
                                    </MaterialTypography>
                                </MaterialBox>
                                <MaterialInput
                                    disabled
                                    value={structureData.monthlyNetSalary}
                                />
                            </Grid> */}
            </Grid>
            <MaterialBox width="100%" display="flex" justifyContent="flex-end" marginTop="3%">
            {editdisplay && (
              <>
              <Box>
              <MaterialButton
                                    variant="gradient"
                                    color="dark"
                                    // disabled={pageState.state === "submitting"}
                                    onClick={onDiscardDesignation}
                                  >
                                    Discard
                                  </MaterialButton>
                                  <MaterialButton
                                    sx={{ m: 2 }}
                                    variant="gradient"
                                    color="dark"
                                    // disabled={pageState.state === "submitting"}
                                    onClick={Updateempolyeesalary}
                                  >
                                    update
                                  </MaterialButton>
              </Box>
                                  </>
            )}
         {!Empdisplay && (
             <MaterialButton
             variant="gradient"
             color="dark"
             disabled={
                 !checkAllFields()
             }
             onClick={handleAddComponent}
           >
             submit
           </MaterialButton>
         )}
          </MaterialBox>
          </MaterialBox>
          <MaterialTypography
            sx={{ mt: 2, mb: 1, color: "rgba(63, 81, 181, 0.83)" }}
            variant="h5"
            fontWeight="bold"
          >
           Salary Details
          </MaterialTypography>
          <MaterialDataGrid
            rows={SalaryList.rows}
            columns={SalaryList.columns}
            checkboxSelection={false}
            isSelectable={false}
            localeText={{
              noRowsLabel: (
                <Stack
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  spacing={1}
                >
                  <MaterialTypography
                    variant="body2"
                    fontWeight="medium"
                    color="text"
                  >
                    No details found
                  </MaterialTypography>
                </Stack>
              ),
            }}
            customHeight="100%"
            noSearch
            noPagination
          />
          <MaterialTypography
            sx={{ mt: 2, mb: 1, color: "rgba(63, 81, 181, 0.83)" }}
            variant="h5"
            fontWeight="bold"
          >
            Earning
          </MaterialTypography>
          <MaterialDataGrid
            rows={EarningListTable.rows}
            columns={EarningListTable.columns}
            checkboxSelection={false}
            isSelectable={false}
            localeText={{
              noRowsLabel: (
                <Stack
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  spacing={1}
                >
                  <MaterialTypography
                    variant="body2"
                    fontWeight="medium"
                    color="text"
                  >
                    No details found
                  </MaterialTypography>
                </Stack>
              ),
            }}
            customHeight="100%"
            noSearch
            noPagination
          />
          <MaterialTypography
            sx={{ mb: 1, color: "rgba(63, 81, 181, 0.83)" }}
            variant="h5"
            fontWeight="bold"
          >
            Deduction
          </MaterialTypography>
          <MaterialDataGrid
            rows={DeductionListTable.rows}
            columns={DeductionListTable.columns}
            checkboxSelection={false}
            isSelectable={false}
            localeText={{
              noRowsLabel: (
                <Stack
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  spacing={1}
                >
                  <MaterialTypography
                    variant="body2"
                    fontWeight="medium"
                    color="text"
                  >
                    No details found
                  </MaterialTypography>
                </Stack>
              ),
            }}
            customHeight="100%"
            noSearch
            noPagination
          />
          <MaterialTypography
            sx={{ mb: 1, color: "rgba(63, 81, 181, 0.83)" }}
            variant="h5"
            fontWeight="bold"
          >
            Benefits
          </MaterialTypography>
          <MaterialDataGrid
            rows={BenifitsListTable.rows}
            columns={BenifitsListTable.columns}
            checkboxSelection={false}
            isSelectable={false}
            localeText={{
              noRowsLabel: (
                <Stack
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  spacing={1}
                >
                  <MaterialTypography
                    variant="body2"
                    fontWeight="medium"
                    color="text"
                  >
                    No details found
                  </MaterialTypography>
                </Stack>
              ),
            }}
            customHeight="100%"
            noSearch
            noPagination
          />
       
        </CardContent>
      </Card>
      )}
    </DashboardLayout>
  );
};

export default AddEmployeeSalary;
